export const REGEXPS = {
  phoneRegExp:
    /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/,
  snilsRegExp: /^(\d{3}-\d{3}-\d{3} \d{2})/,
  dateRegExp: /^(0[1-9]|1\d|2\d|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/,
};
